import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as PaymentActions from './methods.actions';
import * as PaymentSelectors from './methods.selectors';

@Injectable()
export class MethodsFacade {
    private readonly store = inject(Store);

    methods$ = this.store.select(PaymentSelectors.selectPaymentMethods);
    methodsLoaded$ = this.store.select(PaymentSelectors.selectPaymentMethodsLoaded);
    methodsError$ = this.store.select(PaymentSelectors.selectPaymentMethodsError);

    loadPaymentMethods(): void {
        this.store.dispatch(PaymentActions.loadPaymentMethods());
    }
}
